import { Injectable } from '@angular/core';
import { ApiCallerService } from './api/api-caller.service';
import { ApiAdapterService } from './api-adapter.service';
import { map,Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class InquiryService {

  constructor(private apiCaller:ApiCallerService, private apiAdapter: ApiAdapterService) { }
  getInquiryList(param:any): Observable<any> {
    return this.apiAdapter.getTicketPage(param);
  }

  getProblemCategory(): Observable<any> {
    return this.apiAdapter.getProblemCategory();
  }
  getTicketStatus(): Observable<any> {
    return this.apiAdapter.getTicketStatus();
  }
  getResolutionTypeList(): Observable<any> {
    return this.apiAdapter.getResolutionType();
  }
  getSupportTeam(): Observable<any> {
    return this.apiAdapter.getSupportTeam();
  }
}
